<template lang="pug">
div
    .columns.large-8.section-start-end
      | {{ duration(section.starts_at, section.ends_at) }}
    .columns.large-4
      small.space_limit(style='color: gray;' )
        span(v-if="section.show_space_limit && section.has_spaces()")
          | {{ t('app.program.spaces_left', {spaces: section.available_spaces().html()}) }}
        span(v-if="!section.has_spaces()")
          | {{t('app.general.full')}}
    .columns.large-3
        .price {{get_section_fee(state.current_reg.program.display_fee_type, section.price, '$')}}
</template>
<script>
  import helper from "../helper";
  export default{
    mixins: [helper],
    props: ['section'],
  }
</script>
